import { CardContent, Grid } from '@mui/material';

import { Card, InfoField, NO_DATA_PLACEHOLDER } from '@occc-app/design-system';
import { TransactionViewFinalizeRequestData } from './types';

type Props = TransactionViewFinalizeRequestData;

export const TransactionViewFinalizeRequestHeader = (props: Props) => {
  const {
    loyaltySequenceId,
    posType,
    posSequenceId,
    vendorModel,
    interfaceVersion,
    entryMethod,
    host,
    sale,
    fuelPrepay,
    tenderCode,
    tenderSubcode,
  } = props;

  return (
    <Card
      sx={(theme) => ({
        marginBottom: theme.spacing(1),
      })}
    >
      <CardContent>
        <Grid container spacing={3}>
          <Grid item md={3}>
            <InfoField label='POS Type' value={posType} noDataMessage={NO_DATA_PLACEHOLDER} />
          </Grid>

          <Grid item md={3}>
            <InfoField
              label='Vendor Model'
              value={vendorModel}
              noDataMessage={NO_DATA_PLACEHOLDER}
            />
          </Grid>

          <Grid item md={3}>
            <InfoField
              label='Interface Version'
              value={interfaceVersion}
              noDataMessage={NO_DATA_PLACEHOLDER}
              truncate
            />
          </Grid>

          <Grid item md={3}>
            <InfoField
              label='POS Sequence ID'
              value={posSequenceId}
              noDataMessage={NO_DATA_PLACEHOLDER}
              truncate
            />
          </Grid>

          <Grid item md={3}>
            <InfoField
              label='Loyalty Sequence ID'
              value={loyaltySequenceId}
              noDataMessage={NO_DATA_PLACEHOLDER}
              truncate
            />
          </Grid>

          <Grid item md={3}>
            <InfoField
              label='Entry Method'
              value={entryMethod}
              noDataMessage={NO_DATA_PLACEHOLDER}
            />
          </Grid>

          <Grid item md={3}>
            <InfoField label='Host' value={host} noDataMessage={NO_DATA_PLACEHOLDER} truncate />
          </Grid>

          <Grid item md={3}>
            <InfoField label='Sale' value={sale} noDataMessage={NO_DATA_PLACEHOLDER} truncate />
          </Grid>

          <Grid item md={3}>
            <InfoField label='Fuel Prepay' value={fuelPrepay} noDataMessage={NO_DATA_PLACEHOLDER} />
          </Grid>

          <Grid item md={3}>
            <InfoField label='Tender Code' value={tenderCode} noDataMessage={NO_DATA_PLACEHOLDER} />
          </Grid>

          <Grid item md={3}>
            <InfoField
              label='Tender Subcode'
              value={tenderSubcode}
              noDataMessage={NO_DATA_PLACEHOLDER}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
